var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mt-6" }, [
    _c("div", { staticClass: "redesign-table" }, [
      _c("div", { staticClass: "table-wrapper" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "is-zebra" },
          [
            _vm._l(_vm.users, function (user) {
              return _c("div", { key: user.id, staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "cell is-60px-cell has-text-centered" },
                  [_c("user-image", { attrs: { user: user, small: "" } })],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cell is-150px-cell" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: user.firstName,
                        expression: "user.firstName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "input is-small",
                    attrs: { placeholder: "—" },
                    domProps: { value: user.firstName },
                    on: {
                      blur: [
                        function ($event) {
                          return _vm.saveField(user, "firstName")
                        },
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return $event.target.blur()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(user, "firstName", $event.target.value.trim())
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell is-150px-cell" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: user.lastName,
                        expression: "user.lastName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "input is-small",
                    attrs: { placeholder: "—" },
                    domProps: { value: user.lastName },
                    on: {
                      blur: [
                        function ($event) {
                          return _vm.saveField(user, "lastName")
                        },
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return $event.target.blur()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(user, "lastName", $event.target.value.trim())
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell" }, [
                  _vm._v(_vm._s(user.email)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell is-90px-cell has-text-centered" },
                  [
                    _c(
                      "popover",
                      [
                        _c("button", {
                          staticClass: "portal-color-swatch",
                          style: { background: user.avatarColor },
                          attrs: {
                            type: "button",
                            title: user.avatarColorOverride
                              ? "Farbe gewählt"
                              : "Farbe automatisch",
                          },
                        }),
                        _vm._v(" "),
                        _c("template", { slot: "popover" }, [
                          _c(
                            "div",
                            { staticClass: "portal-color-palette" },
                            _vm._l(_vm.avatarColors, function (color) {
                              return _c("button", {
                                key: color,
                                class: {
                                  "is-active": user.avatarColor === color,
                                },
                                style: { background: color },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.saveField(
                                      user,
                                      "avatarColor",
                                      color
                                    )
                                  },
                                },
                              })
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "is-size-7",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.saveField(user, "avatarColor", "")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    automatisch\n                                "
                              ),
                            ]
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cell is-150px-cell" }, [
                  _vm._v(_vm._s(_vm.statusLabel(user))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell is-150px-cell" }, [
                  _vm._v(_vm._s(user.lastLoginAt || "—")),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell is-200px-cell" }, [
                  user.invitePending
                    ? _c(
                        "button",
                        {
                          staticClass: "button is-small",
                          attrs: {
                            title:
                              "Link zum Passwort-Setzen in die Zwischenablage kopieren",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.copyInviteLink(user)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("content_copy"),
                          ]),
                          _vm._v(" Link kopieren"),
                        ]
                      )
                    : _c("span", [_vm._v("—")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell is-150px-cell has-text-centered" },
                  [
                    _c(
                      "toggle-switch",
                      {
                        attrs: {
                          value: user.isActive,
                          "btn-class": "is-small",
                        },
                        on: { input: (value) => _vm.setActive(user, value) },
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v("aktiv"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("gesperrt"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell is-150px-cell has-text-centered" },
                  [
                    _c(
                      "toggle-switch",
                      {
                        attrs: {
                          value: !!user.isAdmin,
                          "btn-class": "is-small",
                        },
                        on: { input: (value) => _vm.setAdmin(user, value) },
                      },
                      [
                        _c("option", { domProps: { value: true } }, [
                          _vm._v("Admin"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: false } }, [
                          _vm._v("Kunde"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "cell is-actions is-100px-cell has-text-centered",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-edit",
                        attrs: {
                          title: user.invitePending
                            ? "Einladung erneut senden (neuer Link)"
                            : "Neuen Passwort-Link senden",
                          disabled: _vm.resendingId === user.id,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.resendInvite(user)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("send"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-delete",
                        attrs: { title: "Portal-Zugang löschen" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.deleteUser(user)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            _vm._v(" "),
            !_vm.isLoading && _vm.users.length === 0
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "cell" }, [
                    _vm._v("Noch keine Portal-Zugänge für diesen Kunden."),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "level mt-3" }, [
      _c("div", { staticClass: "level-left" }, [
        _c("div", { staticClass: "level-item control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.inviteFirstName,
                expression: "inviteFirstName",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            staticStyle: { width: "140px" },
            attrs: { type: "text", placeholder: "Vorname" },
            domProps: { value: _vm.inviteFirstName },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.invite.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inviteFirstName = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.inviteLastName,
                expression: "inviteLastName",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            staticStyle: { width: "140px" },
            attrs: { type: "text", placeholder: "Nachname" },
            domProps: { value: _vm.inviteLastName },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.invite.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inviteLastName = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-item control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.inviteEmail,
                expression: "inviteEmail",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            staticStyle: { width: "320px" },
            attrs: { type: "email", placeholder: "email@kunde.ch" },
            domProps: { value: _vm.inviteEmail },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.invite.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inviteEmail = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary level-item",
            class: { "is-loading": _vm.isInviting },
            attrs: { disabled: !_vm.inviteEmail || _vm.isInviting },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.invite.apply(null, arguments)
              },
            },
          },
          [_vm._v("PortalUser einladen")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row is-header level mb-0" }, [
      _c("div", { staticClass: "level-left" }, [
        _c("h2", { staticClass: "level-item" }, [_vm._v("Portal-Zugänge")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row is-head" }, [
      _c("div", { staticClass: "cell is-60px-cell has-text-centered" }, [
        _vm._v("Avatar"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-150px-cell" }, [_vm._v("Vorname")]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-150px-cell" }, [_vm._v("Nachname")]),
      _vm._v(" "),
      _c("div", { staticClass: "cell" }, [_vm._v("E-Mail")]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-90px-cell has-text-centered" }, [
        _vm._v("Farbe"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-150px-cell" }, [_vm._v("Status")]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-150px-cell" }, [
        _vm._v("Letzter Login"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-200px-cell" }, [
        _vm._v("Einladungslink"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell is-150px-cell has-text-centered" }, [
        _vm._v("Zugang"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cell is-150px-cell has-text-centered",
          attrs: {
            title:
              "Admins (z. B. we-tours-Mitarbeiter) werden im Portal nicht als Zuständige angeboten",
          },
        },
        [_vm._v("Admin")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cell is-actions is-100px-cell has-text-centered" },
        [_vm._v("Aktionen")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }